import React from 'react';
import {
  Box,
  Container,
  Typography,
  Stack,
  Link as MuiLink,
} from '@mui/material';
import { ArrowOutward } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const Footer = () => {
  const platformLinks = [
    ['Marketplace', '/marketplace'],
    ['Benchmarks', '/benchmarks'],
    ['Workbench', '/workbench'],
  ];
  const solutionLinks = [
    ['For AI teams', '/for/ai-teams'],
    ['For data providers', '/for/data-providers'],
    ['For experts', '/for/experts'],
    ['For operators', '/for/operators'],
  ];

  return (
    <Box component="footer" sx={{ bgcolor: '#0D0914', color: '#fff', borderTop: '1px solid rgba(255,255,255,.08)' }}>
      <Container maxWidth="xl" sx={{ pt: { xs: 7, md: 9 }, pb: 4 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={6}>
          <Box sx={{ maxWidth: 460 }}>
            <Stack direction="row" spacing={1.25} alignItems="center">
              <Box sx={{ width: 30, height: 30, display: 'grid', placeItems: 'center', borderRadius: 0, bgcolor: '#5B35C9', fontSize: '.78rem', fontWeight: 800 }}>
                DE
              </Box>
              <Typography sx={{ fontSize: '1.18rem', fontWeight: 750 }}>DataEdge</Typography>
            </Stack>
            <Typography sx={{ mt: 2.5, color: '#A69CAC', lineHeight: 1.7 }}>
              The provenance-first intelligence layer for discovering, validating, refining, and governing the data behind advanced AI.
            </Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 4, sm: 8 }}>
            <Box>
              <Typography sx={{ color: '#756B80', fontSize: '.7rem', fontWeight: 800, letterSpacing: '.14em', mb: 2 }}>SOLUTIONS</Typography>
              <Stack spacing={1.3}>
                {solutionLinks.map(([label, to]) => (
                  <MuiLink key={label} component={Link} to={to} sx={{ color: '#C4BBCB', textDecoration: 'none', '&:hover': { color: '#fff' } }}>
                    {label}
                  </MuiLink>
                ))}
              </Stack>
            </Box>
            <Box>
              <Typography sx={{ color: '#756B80', fontSize: '.7rem', fontWeight: 800, letterSpacing: '.14em', mb: 2 }}>PLATFORM</Typography>
              <Stack spacing={1.3}>
                {platformLinks.map(([label, to]) => (
                  <MuiLink key={label} component={Link} to={to} sx={{ color: '#C4BBCB', textDecoration: 'none', '&:hover': { color: '#fff' } }}>
                    {label}
                  </MuiLink>
                ))}
              </Stack>
            </Box>
            <Box>
              <Typography sx={{ color: '#756B80', fontSize: '.7rem', fontWeight: 800, letterSpacing: '.14em', mb: 2 }}>ACCESS</Typography>
              <Stack spacing={1.3}>
                <MuiLink component={Link} to="/login" sx={{ color: '#C4BBCB', textDecoration: 'none', '&:hover': { color: '#fff' } }}>Sign in</MuiLink>
                <MuiLink component={Link} to="/register" sx={{ color: '#fff', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: .6 }}>
                  Request access <ArrowOutward sx={{ fontSize: 15 }} />
                </MuiLink>
              </Stack>
            </Box>
          </Stack>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          spacing={1}
          sx={{ mt: { xs: 7, md: 9 }, pt: 3, borderTop: '1px solid rgba(255,255,255,.09)' }}
        >
          <Typography sx={{ color: '#6F6678', fontSize: '.76rem' }}>© {new Date().getFullYear()} DataEdge</Typography>
          <Typography sx={{ color: '#6F6678', fontSize: '.76rem' }}>Built for accountable AI data operations.</Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
